import styled from 'styled-components';

import { media } from '@theme/mixins';
import colors from '@theme/colors';

export const Button = styled.button`
  appearance: none;
  border: none;
  background-color: transparent;
  font-size: 14px;
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.75;
  letter-spacing: normal;
  text-align: center;
  cursor: pointer;
  padding: 1rem 4.5rem;
  transition: all 0.5s, background-position 0ms;
  border: 1px solid transparent;
  background-color: ${({ dark }) =>
    dark ? colors['very-light-brown'] : '#1b1b1b'};
  color: ${({ dark }) => (dark ? colors['black'] : colors['white'])};
  margin-bottom: 2.5rem;

  &:hover {
    background-color: transparent;
    color: ${({ dark }) => (dark ? colors['white'] : colors['black'])};
    border-color: ${({ dark }) => (dark ? colors['white'] : colors['black'])};
  }

  &:disabled,
  &[disabled] {
    border: 1px solid ${colors['charcoal']};
    background-color: ${colors['charcoal']};
    background-image: url(${({ image }) => image});
    background-position: 75% 50%;
    background-size: 20px;
    background-repeat: no-repeat;
    color: ${colors['white']};
    cursor: not-allowed;
  }

  ${media.tabletPortraitUp`
    font-size: 16px;
    text-transform: none;
    letter-spacing: 0.125px;
  `};
`;
